import React, {useState} from 'react'
import {UncontrolledPopover} from "reactstrap";
import {
    CustomHeader,
    CustomTableRow,
    CustomTD,
    OptionContainer,
    OptionsContainer,
    StatusSpan,
    StyledTable,
    StyledTableHeader,
    StyledTableHeaderCell
} from "@pages/new-design-components/custom-components";
import {parseToWord} from "@constants/index";
import ThreeDots from '@assets/images/mi_options-vertical.svg';
import Uncontrolled from "@pages/new-design-components/UncontrolledPopover.tsx";


const QuotesTable = ({keys, tableData, goToDetails, deleteContent, withoutDelete = false, quickView, showQuickView = true}) => {

    const generateTableItem = (fleetTask,index) => {
        return keys.map((key) => {
            if (key.key === 'status') {
                return (
                    <CustomTD key={key.key}>
                        <StatusSpan type={fleetTask[key.key]}>
                            {fleetTask[key.key] ? parseToWord(fleetTask[key.key]) : 'N/A'}
                        </StatusSpan>

                    </CustomTD>
                );
            } else if (key.key === 'options') {
                return (
                    <CustomTD key={key.key} className={'cursor-pointer'}>
                        <Uncontrolled quickView={quickView}
                                      showQuickView={showQuickView}
                                      deleteContent={deleteContent}
                                      withoutDelete={withoutDelete}
                                      index={index}
                                      goToDetails={goToDetails} />
                    </CustomTD>
                );
            } else if (key.key === 'stock_no' || key.key === 'vehicle_make' || key.key === 'vehicle_model') {
                const vehicle = fleetTask.vehicle;
                return (
                    <CustomTD key={key.key}>
                        {`${vehicle[key.key].name || vehicle[key.key] || 'N/A'}`}
                    </CustomTD>
                );
            } else if (key.key === 'view') {
                return (
                    <CustomTD key={key.key} color={'#3F8CFF'} onClick={()=>{
                        quickView(index)
                    }}
                              className={'cursor-pointer'}
                              width={'20%'}>
                        View
                    </CustomTD>
                );
            }
            return (
                <CustomTD key={key.key}>
                    {fleetTask[key.key] ? fleetTask[key.key].toString() : 'N/A'}
                </CustomTD>
            );
        });
    };
    return (
        <div className={'table-container'}>
            <StyledTable className={'table-borderless'}>
                <StyledTableHeader className={'header-white-text'}>
                    <tr>
                        {keys.map((key)=>{
                            return <StyledTableHeaderCell className={'border-bottom-0'} key={key.key}>
                                {
                                    key.text
                                }
                            </StyledTableHeaderCell>
                        })}

                    </tr>
                </StyledTableHeader>
                <tbody>
                {
                    tableData.map((fleetTask,index) =>{
                        return  <CustomTableRow key={index}>
                            {
                                generateTableItem(fleetTask,index)
                            }

                        </CustomTableRow>
                    })
                }


                </tbody>
            </StyledTable>
        </div>
    )
}
export default QuotesTable;